import { useCurrentResolvedPath } from './useCurrentResolvedPath';
import { useMatch } from '..';

/**
 *
 * @returns true if the current location is a full match with the current resolved path
 */
export const useIsFullMatchWithCurrentLocation = (): boolean => {
    const currentResolvedPath = useCurrentResolvedPath();
    return !!useMatch({ path: currentResolvedPath, end: true });
};
